(function (app, ng) {

    app.component("colorSelector",
        {
            templateUrl: "/App/Components/ColorSelector/color-selector.component.html",
            controller: colorSelectorController,
            controllerAs: "colorSelector",
            bindings: {
                color: '@',
                defaultColor: '@',
                onColorSelectedFn: "&"
            }
        });

    colorSelectorController.$inject = ["ColorPalette"];
    function colorSelectorController(ColorPalette) {
        var $ctrl = this;

        this.$onInit = function() {
            $ctrl.colorPalette = new ColorPalette($ctrl.defaultColor);
            $ctrl.colors = $ctrl.colorPalette.getColors();
            $ctrl.selectedColor = $ctrl.colorPalette.getColorByHexCode($ctrl.color);
            if ($ctrl.selectedColor.hexCode !== $ctrl.color) {
                $ctrl.unSupportedColor = { hexCode: $ctrl.color, name: "Not Supported", id: -1 };
                $ctrl.colors.push($ctrl.unSupportedColor);
                $ctrl.selectedColor = $ctrl.unSupportedColor;
            }
        }
        
        
        //$ctrl.selectedColor = $ctrl.colors[0];
        $ctrl.selectColor = function () {
            $ctrl.onColorSelectedFn({ color: $ctrl.selectedColor.hexCode });
        }
    }
    
})(window.app, window.angular); //jshint ignore:line